import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HelperService } from '../helper/helper.service';
import { Observable } from 'rxjs';
import { AirportListService } from '../airport/airport-list.service';
import { EnvironmentConfigService } from '../shared/environment-config.service';

@Injectable({
  providedIn: 'root'
})

export class RetailService {
  apiConfig = {
    baseUrl: 'https://api2.travelx.ai',
    // baseUrl: 'http://a.gmr.in',
    path: '/api/getRetailers'
  };
  apiParams: any;


  // tslint:disable-next-line: max-line-length
  constructor(private httpClient: HttpClient, private helperService: HelperService, private airportService: AirportListService, private envService: EnvironmentConfigService) {
    this.initApiParams();

  }

  public set retailServiceApi(value: string) {

  }
  public get retailServiceApi(): string {
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.retailServiceApi = `${this.envService.getRetailersApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }

  initApiParams() {
    this.apiParams = {
      type: 6,
      page: 1,
      perpage: 10,
      tab: 1,
      catlist: 1,
      menu_slug: '',
      location: '',
    };
  }



  getAllStores(airportCode: string, page: number): Observable<any> {
    this.apiParams.airport = airportCode;
    this.apiParams.page = page;
    return this.httpClient.get(this.retailServiceApi);
  }

  filterDataByCategory(category: string): Observable<any> {
    this.apiParams.menu_slug = category;
    return this.httpClient.get(this.retailServiceApi);
  }
  filterDataByLocation(location: string, page: number): Observable<any> {
    this.apiParams.page = page;
    this.apiParams.location = location;
    return this.httpClient.get(this.retailServiceApi);
  }
}
